const GoogleMapOptions = [{
  featureType: 'all',
  elementType: 'labels',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'administrative',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'administrative.neighborhood',
  elementType: 'geometry',
  stylers: [{
    visibility: 'off',
  }],
}, {
  featureType: 'landscape',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'landscape.natural',
  elementType: 'geometry.fill',
  stylers: [{
    visibility: 'on',
  }, {
    color: '#e0efef',
  }],
}, {
  featureType: 'poi',
  elementType: 'geometry.fill',
  stylers: [{
    visibility: 'on',
  }, {
    hue: '#1900ff',
  }, {
    color: '#c0e8e8',
  }],
}, {
  featureType: 'poi.attraction',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }, {
    hue: '#ff0000',
  }],
}, {
  featureType: 'poi.attraction',
  elementType: 'labels',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'poi.attraction',
  elementType: 'labels.icon',
  stylers: [{
    hue: '#ff0000',
  }, {
    saturation: '76',
  }],
}, {
  featureType: 'poi.business',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }, {
    hue: '#00ff00',
  }, {
    saturation: '50',
  }],
}, {
  featureType: 'poi.business',
  elementType: 'labels.icon',
  stylers: [{
    hue: '#ff0000',
  }, {
    visibility: 'on',
  }, {
    saturation: '66',
  }],
}, {
  featureType: 'poi.government',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'poi.government',
  elementType: 'labels.icon',
  stylers: [{
    hue: '#ff0000',
  }, {
    saturation: '100',
  }],
}, {
  featureType: 'poi.medical',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'poi.park',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }, {
    hue: '#00ff74',
  }],
}, {
  featureType: 'poi.place_of_worship',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'poi.school',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'poi.sports_complex',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'road',
  elementType: 'geometry',
  stylers: [{
    lightness: 100,
  }, {
    visibility: 'simplified',
  }],
}, {
  featureType: 'road',
  elementType: 'labels',
  stylers: [{
    visibility: 'off',
  }],
}, {
  featureType: 'road.highway',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }, {
    lightness: '10',
  }, {
    saturation: '-23',
  }, {
    gamma: '1.57',
  }],
}, {
  featureType: 'road.highway',
  elementType: 'geometry',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'road.highway',
  elementType: 'geometry.fill',
  stylers: [{
    color: '#c2cacd',
  }],
}, {
  featureType: 'road.highway.controlled_access',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'road.highway.controlled_access',
  elementType: 'geometry',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'road.arterial',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'road.local',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'transit',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'transit.line',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'transit.line',
  elementType: 'geometry',
  stylers: [{
    visibility: 'on',
  }, {
    lightness: 700,
  }],
}, {
  featureType: 'transit.station',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'transit.station.bus',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'transit.station.rail',
  elementType: 'all',
  stylers: [{
    visibility: 'on',
  }],
}, {
  featureType: 'water',
  elementType: 'all',
  stylers: [{
    hue: '#0047ff',
  }, {
    visibility: 'on',
  }, {
    saturation: '0',
  }, {
    lightness: '0',
  }, {
    gamma: '0.80',
  }],
}, {
  featureType: 'poi',
  elementType: 'labels',
  stylers: [{
    visibility: 'off',
  }],
}]

export default GoogleMapOptions
